import Vue from 'vue'
import CountTo from 'vue-count-to'

Vue.component('CountTo', CountTo)
